
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ name: 'TabButton' })
export default class TabButton<T> extends Vue {
  @Prop({ required: true })
  readonly value!: T;
  @Prop({ required: true })
  readonly tab!: T;
}
